import {css, StyleSheet} from "aphrodite";
import React from 'react';
import Step from "./Step";
import GridStyles from "../styles/styles";
import MediaQuery from "../styles/MediaQuery";
import Config from "../config/Config";

const StepsArea = ({extraStyle}) => {
    const styles = StyleSheet.create({
            container: {
                ...GridStyles.define("auto", "auto auto auto"),
                gridColumnGap: "minmax(10px, 83px)",
                justifyContent: "center",
                ...MediaQuery.dynamic(500, {
                    ...GridStyles.define("max-content max-content max-content", "auto"),
                    gridColumnGap: 0,
                    gridRowGap: 30
                })
            }
        }),
        steps = [
            {step: "1.", text: Config.messages.firstStep},
            {step: "2.", text: Config.messages.secondStep},
            {step: "3.", text: Config.messages.thirdStep}
        ];

    return (
        <div className={css(styles.container, extraStyle)}>
            {steps.map((item, index) => <Step key={index} step={item}/>)}
        </div>
    );
};


export default StepsArea;
